"use client";
import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useSearchParams } from "next/navigation";
import PageLayout from "@/layouts/pageLayout";
import NetworkServicesTabs from "@/components/pageTabs/networkServicesTabs";
import { scrollToElement } from "@/utils/scrollToElement";
import VendorsTabs from "./components/vendors";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import AdvantageComp from "./components/advantages";
import ServiceByOneMind from "./components/serviceByOneMind";
import Solutions from "./components/solutions";
import ComparisonComp from "./components/comparison";

const ID = "vendors-tabs";

const SdnSdWanPage = () => {
  const searchParams = useSearchParams();
  const vendor = searchParams.get("vendor");
  const activeVendor = vendor || "cisco";

  useEffect(() => {
    if (vendor) {
      scrollToElement(ID, 120);
    }
  }, [vendor]);

  return (
    <Box>
      <Hero />
      <PageLayout>
        <NetworkServicesTabs />
        <Box>
          <Intro />
          <AdvantageComp />
        </Box>
        <ServiceByOneMind />
        <VendorsTabs activeVendor={activeVendor} />
      </PageLayout>
      <ComparisonComp />
      <PageLayout showContactForm>
        <Solutions />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default SdnSdWanPage;
